import { API, graphqlOperation } from "aws-amplify";
import { GET_CUSTOM_FIELDS, GET_CUSTOM_FIELDS_SUCCESS, GET_CUSTOM_FIELDS_FAILURE, TRIGGER_TOAST } from "../constants";
import { GetCustomFields } from "./../../queries";

const getCustomFields = (orgId: any) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_CUSTOM_FIELDS });
    const getCustomHandle = API.graphql(graphqlOperation(GetCustomFields(orgId))) as Promise<any>;
    getCustomHandle
      .then(async (getCustomData: any) => {
        const responseParsed = JSON.parse(JSON.parse(getCustomData.data.getOrganizationCustomFields).body) || {};
        if (responseParsed.error) {
          if (responseParsed.error.code == 406) {
            dispatch({ type: GET_CUSTOM_FIELDS_SUCCESS, payload: [] });
          } else {
            dispatch({ type: GET_CUSTOM_FIELDS_FAILURE });
            dispatch({
              type: TRIGGER_TOAST,
              payload: {
                shouldShow: true,
                severity: "error",
                transMessage: "message_errorDefault",
              },
            });
          }
        } else {
          dispatch({ type: GET_CUSTOM_FIELDS_SUCCESS, payload: responseParsed });
        }
      })
      .catch(() => {
        dispatch({ type: GET_CUSTOM_FIELDS_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity: "error",
            transMessage: "message_errorDefault",
          },
        });
      });
  };
};

export default {
  getCustomFields,
};
